// logoutMS = 29 minutes
export const logoutMS = 29 * 60 * 1000;

// idleTimerMS = logoutMS - 1 minute
export const idleTimerMS = logoutMS - 60 * 1000;

// modalExpireMS = 1 minute
export const modalExpireMS = 60 * 1000;

// refreshAccessTokenInSec = 3 minutes
export const refreshAccessTokenInSec = 3 * 60;

// checkTokenExpirationInMs = 1 minute
export const checkTokenExpirationInMs = 60 * 1000;